const commonInputStyles = {
  boxSizing: "border-box",
  flexGrow: 1,
  marginBlockStart: 0,
  marginBlockEnd: 0,
  marginInlineStart: 0,
  marginInlineEnd: 0,
  paddingBlockStart: 0,
  paddingBlockEnd: 0,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "md",
  cursor: "text",
  outline: "none",
  border: "none",
  bg: "transparent",
  fontSize: 3,
  fontFamily: "default",
  fontWeight: "normal",
  letterSpacing: 0,
  lineHeight: "normal",
  color: "foreground.strong",
  ":invalid": {
    boxShadow: "none"
  },
  "::placeholder": {
    opacity: 1,
    // Overrides Firefox default value
    color: "foreground.weak"
  },
  "::-ms-clear": {
    display: "none",
    blockSize: 0,
    inlineSize: 0
  },
  // for Chrome when making autofill selection
  ":-webkit-autofill::first-line": {
    fontSize: 3,
    fontFamily: "default"
  }
};

export { commonInputStyles };
